export function shouldApplyCustomSubmitFollowUp(result) {
  return result?.handled !== true;
}

export function shouldMarkWizardSubmitted(result) {
  if (result?.cancelled) return false;
  return result?.success === true;
}

export function getApiErrorMessage(result, fallback = "Request failed") {
  if (!result) return fallback;
  if (result.success) return null;
  const err = result.error;
  if (err == null) return result.message || fallback;
  if (typeof err !== "object") return String(err);
  if (err.error != null && typeof err.error !== "object") {
    return String(err.error);
  }
  if (err.msg) return String(err.msg);
  if (err.message) return String(err.message);
  return fallback;
}
